(function () {
    angular.module('PWAPoCApp').factory('authInterceptorService', authInterceptorService);

    authInterceptorService.$inject = ['$q', '$window', '$localForage', 'serviceUrls', 'commonUtil'];

    function authInterceptorService($q, $window, $localForage, serviceUrls, commonUtil) {
        return {
            request: request,
            responseError: responseError,
        };

        function request(config) {
            config.headers = config.headers || {};

            return $localForage.getItem("authData").then(function (authData) {
                if (authData) {
                    config.headers.Authorization = "Bearer " + authData.token;
                    config.headers.CustomerId = authData.customerId;
                }
                return config;
            });
        }
        function responseError(response) {
            var deferred = $q.defer();

            if (
                response &&
                response.status === 401 &&
                $window.location.pathname.indexOf("login") === -1
            ) {
                $localForage.removeItem("authData").then(
                    function () {
                        $window.location.href =
                            $window.location.origin + "/login";
                        deferred.resolve();
                    },
                    function () {
                        $q.reject(response);
                        deferred.reject();
                    },
                );
            } else {
                $q.reject(response);
                deferred.reject();
            }

            return deferred.promise;
        }
    }
})();
